export default __webpack_public_path__ + "static/media/aboutBgDec5.4aeed20b.png";